<template>
    <section class="mead-dashboard-item-filter-bar dw-10 f">
        <section class="mead-dashboard-item-filter-bar-sections-list f fg fa-c"
            v-mead-scroll-fade-horizontal
            v-mead-horizontal-wheel-scroll>
            <DashboardItemFilterBarButton v-for="(section, index) in allowedSections"
                :key="index"
                :config="internal_config"
                :section="section"
                :selected-section="hasSelectedSection ? selected_section.section : ''"
                :qa="`dashboard-filter-bar-button-${index}`"
                @click="onOpenSectionPopover($event, section)" />
            <mead-button-icon class="el--transparent" icon="return2" title="mead.reset" @click="resetConfig" />
        </section>
    </section>
</template>
<script>
import { guuid, isObject } from '@aretheyhappy/utils';
import DashboardConfigurationControllerMixin from '../../mixins/DashboardConfigurationControllerMixin';
import DashboardItemFilterBarButton from './DashboardItemFilterBarButton.vue';
import DashboardItemFilterBarPopover from './DashboardItemFilterBarPopover.vue';

/**
 * This component is meant to be an in line filter bar for widgets on
 * dashboards.
 *
 * It operates similarly to DashboardItemConfig.vue.
 */
export default {
    name: 'mead-dashboard-item-filter-bar',
    mixins: [DashboardConfigurationControllerMixin],
    components: {DashboardItemFilterBarButton},
    data () {
        return {
            uid: guuid(),
        };
    },
    methods: {
        /**
         * Opens the full configuration popover for this widget
         */
        onOpenSectionPopover: function (event, section) {
            this.selectSection(section);
            const config = new MeadCommon.PopoverConfig()
                .setComponent(DashboardItemFilterBarPopover)
                .setMovable(true)
                .setNoPad(true)
                .setShowArrow(true)
                .setMobileFull(true)
                .setPlacement('top-start')
                .setEvent(event)
                .setNext(() => {
                    this.selectSection(false);
                })
                .setProps({
                    config: Object.assign({}, this.internal_config),
                    selectedSction: section,
                    childType: this.widgetType,
                    dashboardType: this.dashboardType,
                    dashboard: this.dashboard,
                    pubkey: this.uid,
                });
            MeadCommon.PopoverService.open(config);
        },
        /**
         * Resets the internal config back to the widget's default configuration
         */
        resetConfig: function () {
            const defaults = isObject(this.originalConfig) ? this.originalConfig : {};
            this.internal_config = Object.assign({}, defaults);
            this.sendConfigUpdate(this.internal_config);
        }
    },
    created () {
        this.is_edit_mode = false;
        this.emit_invalid_configs = false;
        MeadCommon.Flash.subscribe(this.uid, `${this.uid}:widget_config_update`, this.sendConfigUpdate);
    },
    destroyed () {
        MeadCommon.Flash.unsubscribe(this.uid);
    },
};
</script>
<style lang="scss" scoped>
.mead-dashboard-item-filter-bar {
    .mead-dashboard-item-filter-bar-sections-list {
        max-width: 100%;
        overflow-x: scroll;
        overflow-y: hidden;

        // overflow-x: scroll gives space for a scrollbar making it look
        // like padding below the widget, so we want to specifically hide it.
        // Firefox:
        scrollbar-width: none;
        // WebKit-based browsers (Chrome, Safari, Opera):
        &::-webkit-scrollbar {
            display: none;
        }
    }
}
</style>